module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Battles-BC.0f7e1fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Battles-BC.jpg
// module id = AvfG
// module chunks = 0